module.exports = {"211004001":"工农街道","211004002":"光华街道","211004003":"新村街道","211004004":"长征街道","211004101":"曙光镇","211004102":"兰家镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211004.json
// module id = 525
// module chunks = 0